import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MainTopComponent } from './layout/main-top/main-top.component';
import { MainBodyComponent } from './layout/main-body/main-body.component';
import { AuthenticationService } from './features/auth/services/auth.service';
import { ToastComponent } from './shared/components/toast/toast.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, MainTopComponent, MainBodyComponent, ToastComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'hubx-rma';
  private readonly authService = inject(AuthenticationService);

  ngOnInit(): void {
    this.authService.handleAuthentication();
  }
}
